import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    isAuthenticated: !!localStorage.getItem('token') || false, 
    nivelUser: localStorage.getItem('nivelUser') || '',
    listaPermissoes: localStorage.getItem('listaPermissoes') || '',
    nome: localStorage.getItem('nome') || '',
    nomeUsuarioSelecionado: localStorage.getItem('nomeUsuarioSelecionado') || '',
    numeroUsuario: localStorage.getItem('numeroUsuario') || '',
    numeroRegistro: localStorage.getItem('numeroRegistro') || '',
    numeroEndereco: localStorage.getItem('numeroEndereco') || '',
    nomeEndereco: localStorage.getItem('nomeEndereco') || '',
    ruaEndereco: localStorage.getItem('ruaEndereco') ||''
  },
  
  getters: {
    isAuthenticated: state => !!state.isAuthenticated,
    token: state => state.token,
    nome: state => state.nome,
    nomeUsuarioSelecionado: state => state.nomeUsuarioSelecionado,
    numeroUsuario: state => state.numeroUsuario,
    numeroRegistro: state => state.numeroRegistro,
    nivel: state => state.nivelUser,
    listaPermissoes: state => state.listaPermissoes,
    numeroEndereco: state => state.numeroEndereco,
    nomeEndereco: state => state.nomeEndereco,
    ruaEndereco: state => state.ruaEndereco
  },

  mutations: {
    
    LOGOUT_USER(state) {
      state.token = null
      state.isAuthenticated = false
      state.nomeUsuarioSelecionado = ''
      localStorage.setItem("token", null)
      localStorage.setItem("nomeUsuarioSelecionado", '')
    },

    SET_CURRENT_NOME_ENDERECO(state, value){
      localStorage.setItem('nomeEndereco', value)
      state.nomeEndereco = value
    },
    
    SET_CURRENT_RUA_ENDERECO(state, value){
      localStorage.setItem('ruaEndereco', value)
      state.ruaEndereco = value
    },

    SET_CURRENT_USER_NIVEL(state, value){
      localStorage.setItem('nivelUser', value)
      state.nivelUser = value
    },

    SET_LISTA_DE_PERMISSOES(state, value){
      const converterParaString = JSON.stringify(value)
      localStorage.setItem('listaPermissoes', converterParaString)
      state.listaPermissoes = converterParaString
    },

    SET_CURRENT_TOKEN(state, token) {
      localStorage.setItem("token", token)
      state.token = token
    },

    ALTER_AUTHENTICATED_STATE(state, value){
        state.isAuthenticated = value
    },

    SET_USER_NAME(state, value){
      localStorage.setItem("nome", value)
      state.nome = value
    },

    SET_USER_NAME_SELECTED(state, value){
      localStorage.setItem("nomeUsuarioSelecionado", value)
      state.nomeUsuarioSelecionado = value
    },

    SET_NUMERO_USUARIO(state, value){
      localStorage.setItem("numeroUsuario", value)
      state.numeroUsuario = value
    },

    SET_NUMERO_REGISTRO(state, value){
      localStorage.setItem("numeroRegistro", value)
      state.numeroRegistro = value
    },

    SET_NUMERO_ENDERECO(state, value){
      state.numeroEndereco = value
    }
  },

  actions: {

    logout({commit}) {
      commit('LOGOUT_USER');
    },

    setToken({commit}, token) {
      commit('SET_CURRENT_TOKEN', token)
    },

    setAuthenticatedState({commit}, value){
      commit('ALTER_AUTHENTICATED_STATE', value)
    },

    setNivelUsuario({commit}, value){
      commit('SET_CURRENT_USER_NIVEL', value)
    },

    setListaPermissoes({commit}, value){
      commit('SET_LISTA_DE_PERMISSOES', value)
    },

    setNome({commit}, value){
      commit('SET_USER_NAME', value)
    },

    setNomeSelecionado({commit}, value){
      commit('SET_USER_NAME_SELECTED', value)
    },

    setNumeroEndereco({commit}, value){
      commit('SET_NUMERO_ENDERECO', value)
    },

    setNumeroUsuario({commit}, value){
      commit('SET_NUMERO_USUARIO', value)
    },

    setNumeroRegistro({commit}, value){
      commit('SET_NUMERO_REGISTRO', value)
    },

    setNomeEndereco({commit}, value){
      commit('SET_CURRENT_NOME_ENDERECO', value)
    },

    setRuaEndereco({commit}, value){
      commit('SET_CURRENT_RUA_ENDERECO', value)
    }


  
  }
});

